document.addEventListener('DOMContentLoaded', function() {
  const popupTrigger$ = document.querySelector('.announcement a[data-popup-trigger]');
  const popup$ = document.querySelector('.custom-popup');
  const closePopup$ = document.querySelector('.close-popup');
  const siteOverlay$ = document.querySelector('.site-overlay');

  if (!popup$ || !popupTrigger$) return;

  function showPopup() {
    popup$.classList.add('active');
    siteOverlay$?.classList.add('active');
  }

  function hidePopup(event) {
    if (!popup$.contains(event.target) && !popupTrigger$.contains(event.target)) {
      popup$.classList.remove('active');
      siteOverlay$?.classList.remove('active');
    }
  }

  popupTrigger$.addEventListener('click', function(event) {
    event.preventDefault();
    showPopup();
  });

  closePopup$.addEventListener('click', function() {
    popup$.classList.remove('active');
    siteOverlay$.classList.remove('active');
  });
  
  document.addEventListener('click', hidePopup);
});
